/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Otherlanguages_Language_Label1Inputs */

const en_cv_extract_form_otherlanguages_language_label1 = /** @type {(inputs: Cv_Extract_Form_Otherlanguages_Language_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const de_cv_extract_form_otherlanguages_language_label1 = /** @type {(inputs: Cv_Extract_Form_Otherlanguages_Language_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Cv_Extract_Form_Otherlanguages_Language_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_otherlanguages_language_label1 = /** @type {((inputs?: Cv_Extract_Form_Otherlanguages_Language_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Otherlanguages_Language_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_otherlanguages_language_label1(inputs)
	return en_cv_extract_form_otherlanguages_language_label1(inputs)
});
export { cv_extract_form_otherlanguages_language_label1 as "cv_extract_form_otherLanguages_language_label" }